import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();

  const navLinks = [
    { name: 'Home', path: '/' },
    { name: 'About', path: '/about' },
    { name: 'Services', path: '/services' },
    { name: 'Packages', path: '/packages' },
    { name: 'Events', path: '/events' },
    { name: 'Blog', path: '/blog' },
    { name: 'Birth Plan', path: '/manual' },
    { name: 'Contact', path: '/contact' },
  ];

  const isActive = (path: string) => location.pathname === path;

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 bg-white/95 backdrop-blur-sm shadow-sm">
      <div className="max-w-7xl mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          {/* Logo */}
          <Link to="/" className="flex items-center">
            <img 
              src="https://static.readdy.ai/image/0e3c418cd49273f94bb710e1b839df62/a9ea4cf408a3a4fb14ecc5c83705b8bc.png" 
              alt="Lotus Maternal Logo" 
              className="h-16 w-16 object-contain"
            />
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center gap-7">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`text-sm font-medium transition-colors whitespace-nowrap ${
                  link.name === 'Events'
                    ? isActive(link.path)
                      ? 'text-pink-600 font-semibold'
                      : 'text-pink-500 hover:text-pink-600 font-semibold'
                    : isActive(link.path)
                    ? 'text-amber-700'
                    : 'text-gray-700 hover:text-amber-700'
                }`}
              >
                {link.name === 'Events' && (
                  <span className="inline-flex items-center gap-1">
                    <i className="ri-calendar-event-line text-xs"></i>
                    {link.name}
                  </span>
                )}
                {link.name !== 'Events' && link.name}
              </Link>
            ))}
            <a
              href="tel:9294738867"
              className="hidden lg:flex items-center gap-1.5 text-amber-700 hover:text-amber-800 transition-colors whitespace-nowrap text-sm font-semibold"
            >
              <div className="w-5 h-5 flex items-center justify-center">
                <i className="ri-phone-fill text-sm"></i>
              </div>
              (929) 473-8867
            </a>
            <a
              href="https://calendly.com/queenbriebirthworker/30min"
              target="_blank"
              rel="noopener noreferrer"
              className="bg-amber-700 text-white px-6 py-2.5 rounded-full text-sm font-medium hover:bg-amber-800 transition-colors whitespace-nowrap"
            >
              Book Consultation
            </a>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsOpen(!isOpen)}
            className="md:hidden w-10 h-10 flex items-center justify-center text-gray-700 hover:text-amber-700 transition-colors cursor-pointer"
            aria-label="Toggle menu"
          >
            <i className={`ri-${isOpen ? 'close' : 'menu'}-line text-2xl`}></i>
          </button>
        </div>

        {/* Mobile Menu */}
        {isOpen && (
          <div className="md:hidden mt-4 pb-4 border-t border-gray-100 pt-4">
            <div className="flex flex-col gap-4">
              {navLinks.map((link) => (
                <Link
                  key={link.path}
                  to={link.path}
                  onClick={() => setIsOpen(false)}
                  className={`text-sm font-medium transition-colors flex items-center gap-1.5 ${
                    link.name === 'Events'
                      ? isActive(link.path)
                        ? 'text-pink-600 font-semibold'
                        : 'text-pink-500 font-semibold'
                      : isActive(link.path)
                      ? 'text-amber-700'
                      : 'text-gray-700 hover:text-amber-700'
                  }`}
                >
                  {link.name === 'Events' && <i className="ri-calendar-event-line text-xs"></i>}
                  {link.name}
                </Link>
              ))}
              <a
                href="tel:9294738867"
                className="flex items-center gap-2 text-amber-700 font-semibold text-sm"
              >
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-phone-fill text-sm"></i>
                </div>
                (929) 473-8867
              </a>
              <a
                href="https://calendly.com/queenbriebirthworker/30min"
                target="_blank"
                rel="noopener noreferrer"
                onClick={() => setIsOpen(false)}
                className="bg-amber-700 text-white px-6 py-2.5 rounded-full text-sm font-medium hover:bg-amber-800 transition-colors text-center whitespace-nowrap"
              >
                Book Consultation
              </a>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navbar;